import { DateTimeISO } from "shared-ts-types";
import { ChimneySensorPlacementStringEnum } from "../../sensor/ChimneySensorPlacementEnum";
import { FlueTypeStringsEnum } from "./FlueType";
import { SootingDegreeCalculationMethod } from "./SootingDegreeCalculationMethod";
import { DateTime } from "luxon";
import { notUndef } from "shared-ts-utils-core";
import { DateTimeUtils } from "shared-ts-utils-luxon";

export interface FlueFieldsDto {
  name?: string;
  type: FlueTypeStringsEnum;
  sensorPlacement: ChimneySensorPlacementStringEnum;
  shared?: boolean;
  problematic: boolean;
  sweepedDuringSensorInstallation: boolean;
  height?: number;
  temperatureAlarmThreshold?: number;
  lastSweepDate?: DateTimeISO;
  lastChimneyFire?: DateTimeISO;
  estimatedSweepDate?: DateTimeISO;
  sootingDegreeCalculationMethod: SootingDegreeCalculationMethod;
}

export class FlueFields {
  readonly name?: string;
  readonly type: FlueTypeStringsEnum;
  readonly sensorPlacement: ChimneySensorPlacementStringEnum;
  readonly shared?: boolean;
  readonly problematic: boolean;
  readonly sweepedDuringSensorInstallation: boolean;
  readonly height?: number;
  readonly temperatureAlarmThreshold?: number;
  readonly lastSweepDate?: DateTime<true>;
  readonly lastChimneyFire?: DateTime<true>;
  readonly estimatedSweepDate?: DateTime<true>;
  readonly sootingDegreeCalculationMethod: SootingDegreeCalculationMethod;

  constructor(args: FlueFieldsDto) {
    this.name = args.name;
    this.type = args.type;
    this.sensorPlacement = args.sensorPlacement;
    this.shared = args.shared;
    this.problematic = args.problematic;
    this.sweepedDuringSensorInstallation = args.sweepedDuringSensorInstallation;
    this.height = args.height;
    this.temperatureAlarmThreshold = args.temperatureAlarmThreshold;
    this.lastSweepDate = notUndef(args.lastSweepDate, (it) =>
      DateTimeUtils.fromISO(it)
    );
    this.lastChimneyFire = notUndef(args.lastChimneyFire, (it) =>
      DateTimeUtils.fromISO(it)
    );
    this.estimatedSweepDate = notUndef(args.estimatedSweepDate, (it) =>
      DateTimeUtils.fromISO(it)
    );
    this.sootingDegreeCalculationMethod = args.sootingDegreeCalculationMethod;
  }

  toDto(): FlueFieldsDto {
    return {
      name: this.name,
      type: this.type,
      sensorPlacement: this.sensorPlacement,
      shared: this.shared,
      problematic: this.problematic,
      sweepedDuringSensorInstallation: this.sweepedDuringSensorInstallation,
      height: this.height,
      temperatureAlarmThreshold: this.temperatureAlarmThreshold,
      lastSweepDate: this.lastSweepDate?.toISO(),
      lastChimneyFire: this.lastChimneyFire?.toISO(),
      estimatedSweepDate: this.estimatedSweepDate?.toISO(),
      sootingDegreeCalculationMethod: this.sootingDegreeCalculationMethod,
    };
  }
}
